import { useParams } from "react-router-dom";
import AdvancedEditView from "@features/tools/view/interactive-materials-view/single-interactive-material-view/advanced-edit";

const AdvancedEditInteractiveMaterial = () => {
  const { id } = useParams<{ id: string }>();
  return <AdvancedEditView id={id!} />;
};

export default AdvancedEditInteractiveMaterial;
